import { render } from "./DataGrid.vue?vue&type=template&id=15ac608c"
import script from "./DataGrid.vue?vue&type=script&lang=js"
export * from "./DataGrid.vue?vue&type=script&lang=js"

import "./DataGrid.vue?vue&type=style&index=0&id=15ac608c&lang=css"

import exportComponent from "C:\\Users\\guilherme.goncalves\\Documents\\FDVSolution\\FDVSolution\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__